"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFailedUserCard = exports.PaymentFailedAdminCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const PaymentFailedAdminCard = (params) => {
    const { amountDue, cancellationDate, rootUrl } = params;
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        text: `$${amountDue} Payment for Polly was unsuccessful`,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "❌  We were unable to charge the card on file for your Polly subscription.",
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Please update your billing information **before ${cancellationDate.toDateString()}** to keep this subscription active.`,
        wrap: true,
    }));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title: "Update Payment Info",
        url: `${rootUrl}/msteams/content/stripe/payments/update`,
        style: adaptivecards_1.ActionStyle.Destructive,
    }));
    return card;
};
exports.PaymentFailedAdminCard = PaymentFailedAdminCard;
const PaymentFailedUserCard = (params) => {
    const { cancellationDate, adminName, adminEmail, tenantId } = params;
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        text: "Your account payment was unsuccessful",
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "❌  We were unable to charge the card on file for your Polly subscription.",
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Please ask @${adminName}, the billing admin, to update their billing information in the Polly Dashboard **before ${cancellationDate.toDateString()}** to keep this subscription active.`,
        wrap: true,
    }));
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title: `Send ${adminName} a message `,
        url: `https://teams.microsoft.com/l/chat/0/0?tenantId=${tenantId}&users=${adminEmail}`,
        style: adaptivecards_1.ActionStyle.Destructive,
    }));
    return card;
};
exports.PaymentFailedUserCard = PaymentFailedUserCard;
//# sourceMappingURL=SubscriptionPaymentFailedCard.js.map